import template from './menuFamilyNeedALoan.html';
import controller from './menuFamilyNeedALoan.controller';
import './menuFamilyNeedALoan.scss';

let menuFamilyNeedALoanComponent = {
  restrict: 'E',
  bindings: {
    onGetSimulationFamilies: '&',
    families: '<',
    simulation: '<',
    selectFamily: '&',
    itemSelected: '<',
    selectedOptionFamily: '<',
    onSelectOptionFamily: '&',
    setSimulation: '&',
    optionFamilySelected: '<',
    getCodeLoan: '&',
    isMobileApp: '<',
    familiesMobile: '<',
    codeOptionSelected: '<',
    optionsFamiliesToSelect: '<',
    housingWitness:'<',
    simulationWitness: '<',
  },
  template,
  controller,
};

export default menuFamilyNeedALoanComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/menuFamilyNeedALoan/menuFamilyNeedALoan.component.js